import { useEffect, useState, useCallback } from "react";
import { deleteCollateralType, addCollateralType, updateCollateralType, getAllCollateralType, reactivateCollateralType } from '../CollateralTypeService'

export default function useCollateralType() {
    const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
    const [collateraltype, setCollateralType] = useState(null);
    const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
    const [shouldOpenReactivateConfirmationDialog, setShouldOpenReactivateConfirmationDialog] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (_, newPage) => setPage(newPage);
    const [collateralTypes, setCollateralTypes] = useState([]);

    useEffect(() => {
        updatePageData();
    }, []);

    const handleEditUser = (collateraltype) => async (event) => {
        setCollateralType(collateraltype);
        setShouldOpenEditorDialog(true);
    };

    const updatePageData = () => {
        getAllCollateralType().then(response => {
            setCollateralTypes(response.data.collateralTypes);
        }).catch(error => {
            console.error('Failed to fetch Collateral Type data', error);
        });
    };

    const handleSave = async (collateraltype, isNew, setFieldError) => {
        let apiPayload;
        if (isNew) {
            apiPayload = {
                Code: collateraltype.Code,
                Description: collateraltype.Description
            };
            const response = await addCollateralType(apiPayload);
            if (response.data.success) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        } else {
            apiPayload = {
                Id: collateraltype.ID,
                Code: collateraltype.Code,
                Description: collateraltype.Description,
                StatusLUId: collateraltype.StatusLUId
            };

            const response = await updateCollateralType(apiPayload);
            if (response.data.success) {
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        }
    };

    const handleDialogClose = () => {
        setShouldOpenEditorDialog(false);
        setShouldOpenConfirmationDialog(false);
        setShouldOpenReactivateConfirmationDialog(false);
        updatePageData();
    };

    const handleConfirmationResponse = () => {
        if (collateraltype) {
            deleteCollateralType(collateraltype.id).then(response => {
                if (response.data.success) {
                    setShowSuccessAlert(true);
                    setTimeout(() => setShowSuccessAlert(false), 3000);
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to delete Collateral Type.');
                }
            }).catch(error => {
                console.error('Error deleting Collateral Type', error);
                alert('Failed to delete Collateral Type.');
            });
        }
    };

    const handleDeleteUser = (user) => {
        setCollateralType(user);
        setShouldOpenConfirmationDialog(true);
    };

    const handleReactivate = (collateraltypeRecord) => {
        setCollateralType(collateraltypeRecord);
        setShouldOpenReactivateConfirmationDialog(true);
    };

    const handleReactivateConfirmationResponse = async () => {
        if (collateraltype) {
            reactivateCollateralType(collateraltype.id).then(response => {
                if (response.data.success) {
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to reactivate Collateral Type.');
                }
            }).catch(error => {
                console.error('Error reactivating Collateral Type', error);
                alert('Failed to reactivate Collateral Type.');
            });
        }
    };

    return {
        setCollateralType,
        setShouldOpenEditorDialog,
        handleEditUser,
        handleDeleteUser,
        shouldOpenEditorDialog,
        page,
        rowsPerPage,
        setRowsPerPage,
        collateraltype,
        handleDialogClose,
        handleSave,
        collateralTypes,
        shouldOpenConfirmationDialog,
        handleConfirmationResponse,
        handleChangePage,
        updatePageData,
        handleReactivate,
        handleReactivateConfirmationResponse,
        shouldOpenReactivateConfirmationDialog,
        setShouldOpenReactivateConfirmationDialog
    }
}